import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=cf0711a0&scoped=true&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0711a0",
  null
  
)

export default component.exports